module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    staticClass: "z-input-zone-cities"
  }, [_c('autocomplete', {
    ref: "search",
    attrs: {
      "property": "value",
      "return": "id",
      "label": "Добавить населённый пункт",
      "display-property": "label",
      "show-save-btn": true,
      "callback": _vm.getCities
    },
    on: {
      "select": _vm.selectCity,
      "save": _vm.addCityToZone,
      "clear": _vm.clearSelectedCity
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), (_vm.selectedCity && _vm.selectedCity.zone && parseInt(_vm.selectedCity.zone.id) != parseInt(_vm.zone.id)) ? _c('div', {
    staticClass: "z-input-zone-cities__preview-city-danger"
  }, [_c('md-icon', [_vm._v("error_outline")]), _c('div', {
    staticClass: "value"
  }, [_c('div', [_c('span', [_vm._v("Внимание! Населённый пункт уже прикреплён к направлению:")]), _c('b', [_vm._v(_vm._s(' ' + _vm.selectedCity.zone.name))])]), _c('div', [_vm._v("При сохранении населённый пункт будет перемещён в текущее направление!")])])], 1) : _vm._e(), (_vm.selectedCity && _vm.selectedCity.zone && parseInt(_vm.selectedCity.zone.id) == parseInt(_vm.zone.id)) ? _c('div', {
    staticClass: "z-input-zone-cities__preview-city-danger"
  }, [_c('md-icon', [_vm._v("error_outline")]), _vm._m(0)], 1) : _vm._e(), (_vm.zoneCities && _vm.zoneCities.length) ? _c('div', {
    staticClass: "z-input-zone-cities__cities-list-container"
  }, [_c('div', {
    staticClass: "z-input-zone-cities__cities-label"
  }, [_vm._v(_vm._s('Прикреплённые населённые пункты' + ' (' + _vm.zoneCities.length + ')'))]), _c('div', {
    staticClass: "z-input-zone-cities__cities-list can-scroll"
  }, _vm._l((_vm.zoneCities), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "z-input-zone-cities__cities-item"
    }, [_c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s((item.value) ? item.value : item.name))]), _c('div', {
      staticClass: "actions"
    }, [_c('md-button', {
      staticClass: "md-icon-button md-dense small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showRemoveDialog(item)
        }
      }
    }, [_c('md-icon', [_vm._v("delete")])], 1), _c('md-tooltip', {
      attrs: {
        "md-direction": "top"
      }
    }, [_vm._v("Открепить населённый пункт")])], 1)])
  }))]) : _vm._e(), _c('md-dialog-confirm', {
    attrs: {
      "md-active": _vm.removeDialog,
      "md-title": "Удалить населённый пункт из направления?",
      "md-content": "Внимание! Действие необратимо!",
      "md-confirm-text": "Удалить",
      "md-cancel-text": "Отмена"
    },
    on: {
      "update:mdActive": function($event) {
        _vm.removeDialog = $event
      },
      "md-cancel": function($event) {
        _vm.removeDialog = false;
        _vm.cityIdToRemove = null;
      },
      "md-confirm": _vm.removeCityFromZone
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value"
  }, [_c('span', [_vm._v("Внимание! Населённый пункт уже прикреплён к текущему направлению!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-532ddd67","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZInputZoneCities.vue
// module id = 1142
// module chunks = 0